export default __webpack_public_path__ + "static/media/info-icon.75a8123f.svg";